import ajax from '../../utils/ajax';

class ResetLoginResponse {
  /**
   * @param {boolean} isSuccess
   * @param {string} message
   */
  constructor(isSuccess, message = null) {
    this.isSuccess = isSuccess;
    this.message = message;
  }
}

/**
 * @param {string} emailAddress
 * @returns {ResetLoginResponse}
 */
async function resetLogin(emailAddress) {
  try {
    await ajax.post('/api/loginreset', { Email: emailAddress });

    return new ResetLoginResponse(true);
  } catch (error) {
    // Endpoint returns a 400 on an invalid email address

    const { responseJSON } = error;

    if (responseJSON && responseJSON.message) {
      return new ResetLoginResponse(false, responseJSON.message);
    }

    throw error;
  }
}

export default {
  resetLogin,
};



// WEBPACK FOOTER //
// ./V7/account/login/ForgotPasswordService.js